import { TemplateMetadataSTORE } from "../templateMetadata/types";
import { SModuleMetadata } from "./types";

interface ObjectWithOrder extends Object {
  order?: number;
}

export const sortModulesOrTemplates = <T extends ObjectWithOrder>(
  dataA: T,
  dataB: T
) => {
  const orderA = dataA.order as number;
  const orderB = dataB.order as number;

  return orderA - orderB;
};
